import { MutableRefObject } from "react";

const DEFAULT_BODY_PADDING = 20;

export function resizeTabs(tabContentRef: MutableRefObject<HTMLElement>) {
  const thisTab = tabContentRef.current;
  if (thisTab && typeof thisTab.getBoundingClientRect !== "undefined") {
    const minHeight = window.innerHeight - thisTab.getBoundingClientRect().top - DEFAULT_BODY_PADDING;
    thisTab.style.minHeight = minHeight + "px";
  }
}
